/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Noheatingtemperature2Inputs */



/**
* | output |
* | --- |
* | "No heating temperature" |
*
* @param {Br_History_Key_Noheatingtemperature2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_noheatingtemperature2 = /** @type {((inputs?: Br_History_Key_Noheatingtemperature2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Noheatingtemperature2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No heating temperature")
	return /** @type {LocalizedString} */ ("Température de non-chauffage")
});
export { br_history_key_noheatingtemperature2 as "br_history_key_noHeatingTemperature" }